import styled from "styled-components"

export const ModalChatContent = styled.div(() => ({
    gap: "32px",
    paddingTop: "32px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    width: "100%",
}))

export const ModalChatItem = styled.button(() => ({
    display: "flex",
    alignItems: "center",
    gap: "32px",
    justifyContent: "space-between",
    border: 0,
    backgroundColor: "transparent",
    cursor: "pointer",
    width: "100%",
}))

export const ModalChatIconWithTitle = styled.div(({ margin }) => ({
    display: "flex",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
    margin: margin ? "32px 0" : ""
}))

export const ModalChatTitle = styled.h3(({ theme }) => ({
    fontSize: '18px',
    lineHeight: '160%',
    fontWeight: 400,
    color: theme.color.neutral["03"],
    [theme.breakpoint.lg()]: {
        fontSize: '20px'
    }
}))

export const ModalChatDivider = styled.div(() => ({
    border: "1px solid #E3E0E2",
    height: "1px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
}))

export const BackButton = styled.button(({ theme }) => ({
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    gap: "4px",
    marginTop: "32px",
    color: theme.color.brandPrimary.light,
}))

export const ContainerBodyOptions = styled.div(() => ({
    maxHeight: "70%",
    overflowY: "scroll",

    "::-webkit-scrollbar": {
        width: "6px",
    },
    "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
        borderRadius: "8px",
    },
    "::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "8px",
    },
    "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
    }
}))

export const DescriptionForOptionsModal = styled.p(({ theme }) => ({
    maxWidth: "436px",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
    color: theme.color.neutral["02"]
}))